import axios from 'axios';
import authService from './authService';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api'
});

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

function forceLogout() {
  authService.logout();
  window.location.href = '/login';
}

api.interceptors.request.use(
  config => {
    const token = authService.getToken();
    if (token) {
      if (isTokenExpired(token)) {
        forceLogout();
        return Promise.reject(new Error('Sessão expirada'));
      }
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      forceLogout();
    }
    return Promise.reject(error);
  }
);

export default api; 